import { createTheme } from '@vanilla-extract/css';
import { semanticColorsV2Tokens } from './semantic-colors-v2.css.ts';
import { themeV2 } from './vars.ts';

export const darkThemeV2 = createTheme(
  themeV2,
  { color: semanticColorsV2Tokens },
  'dark-v2',
);
